'use strict';

var internals = {};

module.exports = function (input) {
  if (!input) {
    return '';
  }

  var lessThan = 0x3C;
  var greaterThan = 0x3E;
  var andSymbol = 0x26;
  var lineSeperator = 0x2028; // replace method

  var charCode;
  return input.replace(/[<>&\u2028\u2029]/g, function (match) {
    charCode = match.charCodeAt(0);

    if (charCode === lessThan) {
      return "\\u003c";
    }

    if (charCode === greaterThan) {
      return "\\u003e";
    }

    if (charCode === andSymbol) {
      return "\\u0026";
    }

    if (charCode === lineSeperator) {
      return "\\u2028";
    }

    return "\\u2029";
  });
};